import { Component, Vue } from 'vue-property-decorator';

@Component<RequestButtonBack>({})
export default class RequestButtonBack extends Vue { }
